import { planTypes } from '@/common/constants';
import logo from '@/assets/plans/zoom_scheduler.svg';
export default {
  data() {
    return {
      logo,
      title: this.$t('billing.scheduler.title'),
      planType: planTypes.ZOOM_SCHEDULER,
    };
  },
};
